import { useEffect, useState } from 'react';

export type ConfirmModalProps = {
  open: boolean;
  title: string;
  body: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  reversibilityNote?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmModal({
  open,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  reversibilityNote,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!open) {
      setArmed(false);
      return;
    }
    const t = setTimeout(() => setArmed(true), 1000); // 1s debounce — spec safety rule.
    return () => clearTimeout(t);
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-md bg-surface-1 border border-border rounded-lg p-5">
        <h2 className="text-lg font-semibold">{title}</h2>
        <div className="mt-2 text-sm opacity-90">{body}</div>
        {reversibilityNote && (
          <p className="mt-3 text-xs opacity-70 italic">{reversibilityNote}</p>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-3 py-1.5 rounded border border-border text-sm hover:bg-surface-2"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={!armed}
            className="px-3 py-1.5 rounded border border-sunset/50 bg-sunset/15 text-sm hover:bg-sunset/25 disabled:opacity-50"
          >
            {armed ? confirmLabel : `${confirmLabel} (1s)`}
          </button>
        </div>
      </div>
    </div>
  );
}
